import axios from "@/api/axiosInstance";
import {
  FetchRegistrationsReportParams,
  FetchRegistrationsReportResponse,
} from "./types";

export const fetchRegistrationsReport = async (
  params: FetchRegistrationsReportParams = {},
): Promise<FetchRegistrationsReportResponse> => {
  const response = await axios.get<FetchRegistrationsReportResponse>(
    "/api/private/reports/registrations",
    { params },
  );
  return response.data;
};
